/* @jsx jsx */

import type { PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search';
import ProjectTypePicker from '@atlassian/jira-project-type-picker';
import type { Props } from './types';
import { getProjectTypes } from './utils';

const Filters = (props: Props) => {
	const { onFilterChange, filters, ariaLabelText } = props;
	const onProjectTypePickerChange = (value: ReadonlyArray<string>): void => {
		onFilterChange({ typeKey: value });
	};

	const onFilterSearchChange = (value: string): void => {
		onFilterChange({ query: value });
	};

	return (
		<FilterContainer>
			<FilterSearch
				value={filters.query}
				onChange={onFilterSearchChange}
				isAlwaysExpanded
				ariaLabelText={ariaLabelText}
				placeholder=""
				hasAutoFocus={false}
				isCompact
				increasedWidth={false}
				placeholderAlwaysVisible={false}
			/>
			<ProjectTypePicker
				ariaLabelText={ariaLabelText}
				defaultSelected={filters.typeKey}
				projectTypes={getProjectTypes()}
				onChange={onProjectTypePickerChange}
			/>
		</FilterContainer>
	);
};

export default Filters;

const FilterContainerStyles = css({
	position: 'relative',
	display: 'flex',
	gap: token('space.200'),
	marginBottom: token('space.200', '16px'),
});

const FilterContainer = ({ children }: PropsWithChildren<{}>) => (
	<div css={FilterContainerStyles}>{children}</div>
);
